import localeText from "../../../../locale";
import { LANGUAGE_FIELDS } from "../../utils/catalogUtils";
import FormField from "./FormField";

// Os quatro campos de descrição (PT, EN, IT, ES) em grade 2x2
const TranslationFields = ({ values, onChange, errors = {}, idPrefix, autoFocus = false }) => (
  <fieldset className="admin-form__fieldset">
    <legend className="admin-form__legend">{localeText("adminFormTranslations")}</legend>
    <div className="admin-form__grid">
      {LANGUAGE_FIELDS.map(({ lang, field, labelKey }, index) => (
        <FormField
          key={field}
          label={localeText(labelKey)}
          htmlFor={`${idPrefix}-${lang}`}
          error={errors[field]}
          required
        >
          <input
            id={`${idPrefix}-${lang}`}
            className="admin-input"
            value={values[field] || ""}
            onChange={(e) => onChange({ ...values, [field]: e.target.value })}
            autoFocus={autoFocus && index === 0}
            autoComplete="off"
          />
        </FormField>
      ))}
    </div>
  </fieldset>
);

export default TranslationFields;
